import { Col, Media, Row } from 'react-bootstrap';
import InlineTooltip from '../../../../../../components/common/ToolTip';
import * as React from 'react';
import { groupBy } from '../state/productHelper';

type AdditionalProductsProps = {
    products: any;
    onClickProduct: (id: number) => void;
};

export function AdditionalProducts({ products, onClickProduct }: AdditionalProductsProps) {
    let groupedProducts = groupBy('productType', products);

    return (
        <>
            {Object.keys(groupedProducts)
                .sort()
                .map((groupProperty: string) => (
                    <Row key={groupProperty}>
                        <div className="rowlabel">
                            {groupedProducts[groupProperty][0].productTypeName}
                        </div>
                        {groupedProducts[groupProperty].map((x: any, index: number) => (
                            <Col key={x.id + '-' + index} xs={12} sm={6} md={4} lg={3}>
                                <Media
                                    className={
                                        'product-box ' +
                                        (x.available ? 'extras ' : 'disabled ') +
                                        (x.selected && x.available ? 'selected ' : ' ') +
                                        (x.required && x.selected && x.available ? 'required ' : ' ')
                                    }
                                    onClick={() => onClickProduct(x.id)}
                                >
                                    <Media.Left align="middle">
                                        <i className="material-icons">add_a_photo</i>
                                    </Media.Left>
                                    <Media.Body>
                                        <Col sm={8}>
                                            <h5>{x.name} </h5>
                                        </Col>
                                        {x.priceBrokerFirm !== null ? (
                                            <Col sm={4} className="price-broker-firm">
                                                <p>
                                                    {x.priceBrokerFirm.value}
                                                    {x.currencySign}
                                                </p>
                                            </Col>
                                        ) : (
                                            ''
                                        )}
                                    </Media.Body>
                                    <Media.Right align="middle">
                                        <InlineTooltip id={x.id} tooltip={x.extraText} />
                                    </Media.Right>
                                </Media>
                            </Col>
                        ))}
                    </Row>
                ))}
        </>
    );
}
